import React, { forwardRef, useImperativeHandle, type ForwardedRef } from 'react';

import { usePaginatedTableV8 } from './hooks/use-paginated-table-v8';
import { TableV8Chrome } from './table-v8-chrome';
import type {
  TablePaginatedV8CoreComponent,
  TablePaginatedV8CoreProps,
  TablePaginatedV8Ref,
} from './table-types';

export type { TablePaginatedV8CoreProps, TablePaginatedV8CoreComponent };

function TablePaginatedV8CoreInner<TData extends object>(
  props: TablePaginatedV8CoreProps<TData>,
  ref: ForwardedRef<TablePaginatedV8Ref<TData>>,
) {
  const tableState = usePaginatedTableV8(props, null);

  useImperativeHandle(ref, () => ({ table: tableState.table }), [tableState.table]);

  return (
    <TableV8Chrome
      props={props}
      table={tableState.table}
      displayData={tableState.displayData}
      saveColumns={tableState.saveColumns}
      scrollContainerStyle={tableState.scrollContainerStyle}
      handlePageChange={tableState.handlePageChange}
      handlePageSizeChange={tableState.handlePageSizeChange}
    />
  );
}

const TablePaginatedV8CoreBase = forwardRef(TablePaginatedV8CoreInner);
TablePaginatedV8CoreBase.displayName = 'TablePaginatedV8Core';

/** Read-only server-side paginated grid (no inline editing). */
export const TablePaginatedV8Core =
  TablePaginatedV8CoreBase as TablePaginatedV8CoreComponent;
